import React, { forwardRef } from 'react';
import { Table } from 'reactstrap';
import './style.scss';

const DataToPrint = forwardRef(({ data }, ref) => {
  const dateFormat = type => {
    if (type === 'date') {
      return data.invoice?.date.split(' ')[0];
    }
    if (type === 'time') {
      return data.invoice?.date.split(' ')[1];
    }
  };

  return (
    <div ref={ref} class='invoiceToPrintContainer'>
      <Table>
        <tbody>
          <tr>
            <th colSpan={4} className='center'>
              <h3>{locales('factor') + ' ' + data.invoice?.cafeName}</h3>
              <span> {data.printerTitle}</span>
            </th>
          </tr>
          <tr>
            <th colSpan={4} className='center'>
              <h2>
                {' '}
                {locales('factor.number') +
                  ' : ' +
                  data.invoice?.invoiceNumber}{' '}
              </h2>
            </th>
          </tr>
          <tr>
            <td colSpan={4} className='lighter'>
              <div className='d-flex justify-content-between mx-2'>
                <span>
                  {locales('labels.hour') + ' : ' + dateFormat('time')}
                </span>
                <span>
                  {locales('tables.date') + ' : ' + dateFormat('date')}
                </span>
              </div>
              <div className='d-flex justify-content-center mt-2 '>
                <div>{locales('label.reserve.number')} : </div>

                <div className='mx-2' style={{ direction: 'ltr' }}>
                  {data.invoice?.reserveNumber}
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <th colSpan={4} className='center'>
              <h1>
                {locales('fields.table.no') +
                  ': ' +
                  data.invoice?.tableNumbers}
              </h1>
            </th>
          </tr>

          <tr>
            <td className='center lighter width1rem p-0 m-0'>
              {locales('tables.row')}
            </td>
            <td className='center lighter p-0 m-0' colSpan={2}>
              {locales('tables.title')}
            </td>
            <td className='center lighter width1rem py-0'>
              {locales('labels.qty')}
            </td>
          </tr>
          {data.invoice?.items.map((item, i) => {
            return (
              <tr key={item.title}>
                <td className='center light font-weight-normal'>{i + 1}</td>
                <td className='items py-2' colSpan={2}>
                  {item.title}
                </td>
                <td className='center items'>{item.count}</td>
              </tr>
            );
          })}
          {data.invoice?.additionalInfo.map(item => {
            return (
              <tr key={item}>
                <td className='center' colSpan={4}>
                  <h1 className='additinalInfo'>
                    {item}
                  </h1>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
});

export default DataToPrint;
